<template>
  <div>
    <el-row>
      <el-col :span="18" :offset="3" style="padding: 10px;">
        <div class="indexIntroduction">
          <div
            id="indexIntroductionText"
            class="indexIntroductionIntion"
            style="flex-direction: column;"
            v-if="searchAttrs && searchAttrs.homeText"
          >
            <h2 class="h2style">
              {{ searchAttrs.homeText.title }}
            </h2>
            <p class="pstyle" v-html="searchAttrs.homeText.content"></p>
          </div>
          <div class="indexIntroductionIntion">
            <img alt="" :src="imgPath" class="indexIntroductionImg" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { pathConfig } from '../assets/util/baseConfig'

export default {
  props: {
    searchAttrs: {
      type: Object
    },
    backgroundImage: {
      type: String
    }
  },
  data() {
    return {
      pathConfig: pathConfig,
      imgHeight: 0
    }
  },
  computed: {
    imgPath() {
      if (this.backgroundImage !== '') {
        return this.pathConfig.indexImgPath + this.backgroundImage
      }

      return ''
    }
  }
}
</script>

<style scope>
.indexIntroduction {
  border: 1px solid;
  padding: 5px;
  display: flex;
}
.indexIntroductionIntion {
  /* margin-top: 10px; */
  margin-left: 20px;
  /* margin-bottom: 10px; */
  width: 48%;
  display: flex;
  align-items: stretch;
}
.indexIntroductionImg {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
}
.pstyle {
  text-align: justify;
}
.ql-size-small {
  font-size: .75em;
}
.ql-size-large {
  font-size: 1.5em;
}
.ql-size-huge {
  font-size: 2.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/indexIntroduction.vue